






































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import { UserPhone, judgePhoneLogin } from "@/req/login";
import { getPhoneCode, checkPhoneCode, changeNoPwd } from "@/req/user";
@Component
export default class Logout extends Vue {
  public loginShow = 11;
  public pwdshow = "icons/login3.png";
  public flg = true;
  public clause = true;
  public errorHint = false;
  public hint = false; // 提示弹框
  public isDisable = false;
  public smsCountTime = true;
  public countdown = 60;
  public timer: any = "";
  public exist = false;
  public existlog = false;
  public msgs = "手机号格式错误";
  public msgpwd = "密码格式错误";
  public textC = false;
  public getToken = "";
  public formLogin = {
    password: "",
    phone: "",
    code: "",
    promote_code: "",
  };
  @Watch("formLogin", { deep: true })
  public handleWatch() {
    if (this.formLogin.phone !== "") {
      this.textC = true;
    } else {
      this.textC = false;
    }
    if (this.formLogin.password !== "") {
      this.exist = true;
    } else {
      this.exist = false;
    }
    if (this.formLogin.phone !== "" || this.formLogin.code !== "") {
      this.existlog = true;
    } else {
      this.existlog = false;
    }
  }

  public drawVack() {
    this.errorHint = false;
    if (!this.errorHint) this.loginShow = 2;
  }
  public skipPage(id) {
    if (id == 1) {
      this.$fn.userRecord(3006, 2);
      this.$fn.userRecord(3100, 1);
    } else if (id == 3) {
      this.$fn.userRecord(3005, 2);
      this.$emit("loginShow", "");
    }
    this.$emit("login", id);
  }
  // 下一步
  public lognext() {
    this.$fn.userRecord(3004, 2);
    if (!this.clause) {
      this.hintsh();
      return;
    }
    if (this.formLogin.phone === "") {
      this.msgTs("电话号码不能为空");
      return;
    }
    if (this.formLogin.code === "") {
      this.msgTs("验证码不能为空");
      return;
    }
    this.errorHint = false;
    this.checkCode();
  }

  // 登录
  public loginnext() {
    if (!this.clause) return this.hintsh();
    if (this.formLogin.password === "") return this.msgTs("密码不能为空");
    if (this.formLogin.password.length < 6) {
      this.msgTs("密码不能小于六位");
      return;
    }
    this.login();
  }
  // 勾选提示
  public hintsh() {
    this.hint = true;
    setTimeout(() => {
      this.hint = false;
    }, 2000);
  }
  // 获取焦点
  public foucs(val) {
    if (val == 'phone') this.$fn.userRecord(3001, 3);
    if (val == 'code') return this.$fn.userRecord(3003, 3);
    this.errorHint = false;
  }
  // 失去焦点
  public blur() {
    if (this.formLogin.phone.length <= 6) {
      this.msgTs("手机号格式错误");
      return;
    }
    this.errorHint = false;
  }
  // 设置密码失去焦点
  public pwdBlur() {
    if (
      this.formLogin.password.length < 6 ||
      this.formLogin.password.length > 20 ||
      this.formLogin.password == ""
    ) {
      this.msgTs("密码格式错误")
    }
  }
  public clearBlank() {
    this.formLogin.phone = this.formLogin.phone.replace(/[^0-9]/g, "");
  }
  public clearSpace() {
    this.formLogin.password = this.formLogin.password.replace(/[^a-zA-Z0-9]/g, "");
  }

  public msgTs(val) {
    this.errorHint = true;
    if (this.loginShow != 7) {
      this.msgs = val;
      return;
    }
    this.msgpwd = val;
  }

  // 注册
  public async login() {
    if (!this.clause) {
      this.hint = true;
    }
    const obj = {
      phone: this.formLogin.phone,
      password: this.formLogin.password,
      promote_code: this.formLogin.promote_code,
      code: this.formLogin.code,
    };
    const res = await UserPhone(obj);
    if (res.code == 200) {
      this.$fn.cookies.setToken(res.data.token);
      (window as any).location.reload();
      (this as any).$toast(false);
    } else {
      this.msgTs(res.msg);
    }
    // const obj = {
    //   token: this.getToken,
    //   newpassword: this.formLogin.password,
    //   repassword: this.formLogin.password,
    // };
    // const res = await changeNoPwd(obj);
    // if (res.code == 200) {
    //   this.$fn.cookies.setToken(res.data.token);
    //   (window as any).location.reload();
    //   (this as any).$toast(false);
    // } else {
    //   this.msgTs(res.msg);
    // }
  }
  // 获取手机验证码
  public async gain() {
    this.$fn.userRecord(3002, 2);
    if (!this.$fn.phoneFormat(this.formLogin.phone)) return this.msgTs("手机号格式错误");
    const obj = {
      phone: this.formLogin.phone,
    };
    const res = await getPhoneCode(obj);
    if (res.code == 200) {
      this.smsCountDown();
      this.smsCountTime = false;
    } else {
      this.msgTs(res.msg);
    }
  }
  // 校验手机验证码
  public async checkCode() {
    const obj = {
      phone: this.formLogin.phone,
      code: this.formLogin.code,
    };
    const res = await checkPhoneCode(obj);
    if (res.code == 200) {
      this.PhoneLogin();
      return;
    }
    this.msgTs("验证码不正确");
  }

  // 登录,账号不存在则注册
  public async PhoneLogin() {
    const obj = {
      phone: this.formLogin.phone,
      promote_code: this.formLogin.promote_code,
      code: this.formLogin.code,
    };
    const res = await judgePhoneLogin(obj);
    if (res.code == 200) {
      // if (res.data.change_pwd == 1) {
      //   this.getToken = res.data.token;
      //   this.loginShow = 7;
      //   return;
      // }
      this.$fn.cookies.setToken(res.data.token);
      localStorage.setItem("loginMethod", "note");
      this.$fn.userRecord(3010, 1);
      (window as any).location.reload();
      (this as any).$toast(false);
      return;
    } else {
      this.msgTs(res.msg);
    }
  }

  // 短信验证码倒计时
  public smsCountDown() {
    const self = this;
    this.timer = setInterval(() => {
      self.countdown--;
      if (self.countdown === 0) {
        clearInterval(self.timer);
        self.countdown = 60;
        self.smsCountTime = true;
      }
    }, 1000);
  }
  public pwdsh() {
    this.pwdshow = this.flg ? "icons/login6.png" : "icons/login3.png";
    this.flg = !this.flg;
  }
  public getImgUrl() {
    return require(`@/assets/${this.pwdshow}`);
  }
  public getUrl(val) {
    let url: any = "";
    if (!(val === "serve")) {
      url = "http://list.dhsf.xqhuyu.com/Privacy-policy.html";
    } else {
      url = "http://list.dhsf.xqhuyu.com/user-agreement.html";
    }
    window.open(url)
  }
}
